(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomTaskTypeAttributeDetailController', CustomTaskTypeAttributeDetailController);

    CustomTaskTypeAttributeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CustomTaskTypeAttribute'];

    function CustomTaskTypeAttributeDetailController($scope, $rootScope, $stateParams, previousState, entity, CustomTaskTypeAttribute) {
        var vm = this;

        vm.customTaskTypeAttribute = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:customTaskTypeAttributeUpdate', function(event, result) {
            vm.customTaskTypeAttribute = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
